<template>
  <ul class="vertical highlight_list">
    <li v-for="(entry,index) in filteredHeroes" :key="index">
      <span v-for="key in columns" v-html="entry[key]" @click="getAreaCode(entry[key])" :key="key"></span>
    </li>
  </ul>
</template>

<script>
  import $ from 'jquery';
  export default {
    name: 'AreaCodeGrid',
    props: ['heroes','columns','filterKey','areaCode','country'],
    data () {
      return {
        sortKey: "",
        sortOrders: {}
      };
    },
    computed: {
      filteredHeroes: function () {
        var sortKey = this.sortKey;
        var filterKey = this.filterKey && this.filterKey.toLowerCase();
        var order = this.sortOrders[sortKey] || 1;
        var heroes = this.heroes;
        if (filterKey) {
          heroes = heroes.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
            });
          });
        }
        if (sortKey) {
          heroes = heroes.slice().sort(function (a, b) {
            a = a[sortKey];
            b = b[sortKey];
            return (a === b ? 0 : a > b ? 1 : -1) * order;
          });
        }
        return heroes;
      }
    },
    filters: {
      capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },

    },
    methods: {
      // sortBy: function (key) {
      //   this.sortKey = key;
      //   this.sortOrders[key] = this.sortOrders[key] * -1;
      // }
      getAreaCode (value){
        // var selectAreaCode = $(value).attr('data-code')
        // var selectCountry =  $(value).attr('data-country')
        // this.$emit("areaCode", selectAreaCode)
        // this.$emit("country", selectCountry)
        // // this.areaCode = selectAreaCode
        // // this.country = selectCountry
        // console.log(selectCountry)
        this.$emit('getAreaCode',value)

      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AreaCodeGrid.vue